module.exports = __webpack_public_path__ + "img/Speaker=Sophia Dhrolia.db7d2f5c.png";